import { useEffect, useRef, useState } from "react";

const useIntersectionObserver = <T extends HTMLElement = HTMLDivElement>(
  options: IntersectionObserverInit,
) => {
  const ref = useRef<T | null>(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    if (!ref.current) return;

    const observer = new window.IntersectionObserver(
      ([entry]) => setInView(entry.isIntersecting),
      options,
    );

    observer.observe(ref.current);

    return () => {
      observer.disconnect();
    };
  }, [options]);

  return { ref, inView };
};

export { useIntersectionObserver };
